import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_MEMBER_PHONE_COLLECTION = createFcmDetails('member_phone_collection', {
	owner: 'Membership',
	context: 'Membership Page',
	description: 'If true, phone number collection input will be visible for all users other than secure guests',
	import: false,
});
